module.exports = __webpack_public_path__ + "img/niedermayr-logo.5efe0e12.png";